export default __webpack_public_path__ + "static/media/circle.9bc04bed.png";